import React from 'react'
import { Button } from '@components/Button/Button'
import Footer from '@components/Footer'
import Header from '@components/Header'
import Page from '@components/Page'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from '@hooks/useClinic'
import { Phone } from '@components/icons/Phone'
import { onPhoneClick } from 'src/utils/onPhoneClick'
import { BookByPhoneScreen } from '@screens/BookByPhone/BookByPhoneScreen'

export const BookByPhone = () => {
  const { clinicId } = useConfig()
  const { data } = useClinic(clinicId)

  return (
    <Page
      header={<Header desktopHeadingText="" mobileHeadingText="" hideStatusBar />}
      body={<BookByPhoneScreen />}
      footer={
        <Footer
          button={
            <Button
              defaultWidth
              text={data?.phone}
              phoneSize="xl"
              startIcon={<Phone width={18} height={18} />}
              onClick={() => onPhoneClick(data?.phone)}
            />
          }
        />
      }
    />
  )
}
